
define('template!ssSiteMain',['directive!sdsAuthenticationRequired','directive!ssSiteMainAuthenticated'],function(template){return '<div sds-authentication-required layout-fill>\r\n    <ss-site-main-authenticated class="ss-container ss-body"></ss-site-main-authenticated>\r\n</div>';});

